import { gql } from '@apollo/client';
import type { OnboardingUserStep, OnboardingUserStepData } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLOnboardingChecklistRequester {
  public getOnboardingChecklist = (): Promise<OnboardingUserStepData[]> => {
    return graphQLRequester
      .query<{ onboarding: OnboardingUserStepData[] }>({
        query: gql`
          query onboardingChecklist {
              onboarding {
                step_id
                name
                category
                finished
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.onboarding);
  };

  public updateOnboardingChecklist = (stepId: string, finished: boolean): Promise<OnboardingUserStep> => {
    return graphQLRequester
      .mutate<{ updateOnboarding: OnboardingUserStep }>({
        mutation: gql`
        mutation updateOnboarding($input: OnboardingInput!) {
          updateOnboarding(input: $input) {
            step_id
            finished
          }
        }
      `,
        variables: { input: { stepId, finished } },
      })
      .then((graphQlResponse) => graphQlResponse.updateOnboarding);
  };
}
